import type { ActivationReadiness } from '@features/ownedParkingManage/types/activation';

import { RouteName } from '@router/routeNames';

export const ROUTES_TO_ACHIEVE: Record<keyof ActivationReadiness['steps'], RouteName> = {
  spotsFulfilled: RouteName.MY_PARKING_MANAGE_SPOTS,
  entranceImagesFulfilled: RouteName.MY_PARKING_MANAGE_GALLERY,
  settlementsFulfilled: RouteName.MY_PARKING_MANAGE_BILLING_SELECTION,
};
